import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';

interface ShowButtonState {
  showButton: boolean;
  message: string | null;
  visitado: boolean | null;
}

@Injectable({
  providedIn: 'root'
})
export class ShowButtonService {
  private stateSource = new BehaviorSubject<ShowButtonState>({
    showButton: true,
    message: null,
    visitado: null,
  });

  currentState$ = this.stateSource.asObservable();

  // ✅ Nueva propiedad: señal derivada
  readonly currentState = toSignal(this.currentState$, {
    initialValue: {
      showButton: true,
      message: null,
      visitado: null,
    }
  });

  changeShowButton(showButton: boolean) {
    const currentState = this.stateSource.value;
    this.stateSource.next({
      ...currentState,
      showButton
    });
  }

  changeMessage(message: string | null) {
    const currentState = this.stateSource.value;
    this.stateSource.next({
      ...currentState,
      message
    });
  }

  changeVisitado(value: boolean | null) {
    const currentState = this.stateSource.value;
    this.stateSource.next({
      ...currentState,
      visitado: value
    });
  }
}